import { buildAuthHref } from './urls'

export const SOCIAL_AUTH_POPUP_COMPLETE_PATH = '/login/social-auth-complete'
export const SOCIAL_AUTH_MESSAGE_TYPE = 'giphy-social-auth'
export const SOCIAL_AUTH_POPUP_FEATURES =
    'width=520,height=720,menubar=no,toolbar=no,location=yes,status=no,scrollbars=yes,resizable=yes'

export type SocialAuthProvider = 'apple' | 'facebook'

export type SocialAuthPopupMessage = {
    status: 'success'
    type: typeof SOCIAL_AUTH_MESSAGE_TYPE
}

export const buildSocialAuthPopupHref = (href: string) => buildAuthHref(href, SOCIAL_AUTH_POPUP_COMPLETE_PATH)

export const isSocialAuthPopupMessage = (value: unknown): value is SocialAuthPopupMessage => {
    if (!value || typeof value !== 'object') {
        return false
    }

    const data = value as Record<string, unknown>
    return data.type === SOCIAL_AUTH_MESSAGE_TYPE && data.status === 'success'
}
